export default __webpack_public_path__ + "static/media/ic_marker_mer.25b55c44.svg";